import { FAIR_STATUS } from "@/components/fair/FairOrderRow";
import { tl, itemPairs, itemAmount, discountRate } from "@/lib/fair";

// Total koli per model/color across all fair orders, split by status
export default function FairSummary({ orders, products }) {
  const rows = {};
  orders.forEach((o) => o.items.forEach((it) => {
    const r = rows[it.fair_product_id] = rows[it.fair_product_id] || { pending: 0, converted: 0, cancelled: 0, pairs: 0, amount: 0, customers: new Set() };
    r[o.status] += it.koli;
    r.pairs += itemPairs(it);
    r.amount += itemAmount(it) * (1 - discountRate(o));
    r.customers.add(o.customer_id);
  }));
  const list = products.filter((p) => rows[p.id]).map((p) => ({ p, ...rows[p.id], total: rows[p.id].pending + rows[p.id].converted + rows[p.id].cancelled }))
    .sort((a, b) => b.total - a.total);
  const sum = (k) => list.reduce((a, r) => a + r[k], 0);
  const th = "py-2.5 px-3 text-[11px] font-mono uppercase tracking-widest text-[#6B5B4A]";
  const td = "py-2.5 px-3";

  if (!list.length) return <div className="rounded-lg border border-[#DCCFB8] bg-[#FFFBF4] p-10 text-center text-[#8C7B68]" data-testid="fair-summary-empty">Henüz fuar siparişi yok.</div>;

  return (
    <div className="rounded-lg border border-[#DCCFB8] bg-[#FFFBF4] overflow-x-auto" data-testid="fair-summary">
      <table className="w-full text-sm">
        <thead className="bg-[#EFE6D6]">
          <tr className="text-left">
            <th className={th}>Model</th><th className={th}>Renk</th><th className={`${th} text-right`}>Müşteri</th>
            {Object.entries(FAIR_STATUS).map(([k, v]) => <th key={k} className={`${th} text-right`}>{v.label}</th>)}
            <th className={`${th} text-right`}>Toplam Koli</th>
            <th className={`${th} text-right`}>Toplam Çift</th>
            <th className={`${th} text-right`}>Tutar <span className="normal-case">(iskontolu, KDV hariç)</span></th>
          </tr>
        </thead>
        <tbody>
          {list.map((r) => (
            <tr key={r.p.id} className="border-t border-[#E8DDCA]" data-testid={`fair-summary-row-${r.p.id}`}>
              <td className={`${td} font-mono font-bold text-[#B45309]`}>{r.p.model_code}</td>
              <td className={td}>{r.p.model_color}</td>
              <td className={`${td} text-right font-mono`}>{r.customers.size}</td>
              {Object.keys(FAIR_STATUS).map((k) => <td key={k} className={`${td} text-right font-mono`}>{r[k] || "—"}</td>)}
              <td className={`${td} text-right font-mono font-bold text-lg`} data-testid={`fair-summary-total-${r.p.id}`}>{r.total}</td>
              <td className={`${td} text-right font-mono`}>{r.pairs}</td>
              <td className={`${td} text-right font-mono font-bold`} data-testid={`fair-summary-amount-${r.p.id}`}>{tl(r.amount)}</td>
            </tr>
          ))}
          <tr className="border-t-2 border-[#DCCFB8] font-bold bg-[#EFE6D6]/50">
            <td className={td} colSpan={3}>TOPLAM</td>
            {Object.keys(FAIR_STATUS).map((k) => <td key={k} className={`${td} text-right font-mono`}>{sum(k)}</td>)}
            <td className={`${td} text-right font-mono text-lg`} data-testid="fair-summary-grand-total">{sum("total")}</td>
            <td className={`${td} text-right font-mono`}>{sum("pairs")}</td>
            <td className={`${td} text-right font-mono text-lg`} data-testid="fair-summary-grand-amount">{tl(sum("amount"))}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
